import { useAccountFeatureConfigsContext } from './AccountFeatureConfigsContext';

export interface AccountFeatureConfigs {
  suppressPricingSuggestions: boolean;
  wasSmbMigrated: boolean;
  migratedFromSmbDate: string | null;
}

/**
 * Returns the account configuration details for the primary account of the currently logged in user
 */
export default function useAccountFeatureConfigs(): AccountFeatureConfigs {
  const { accountFeatureConfigs } = useAccountFeatureConfigsContext();

  // If no feature configs are found, return an empty array
  const featureConfigs = accountFeatureConfigs?.featureConfigs ?? [];

  // If this feature is enabled, then pricing suggestions in the app are suppressed for this user
  const suppressPricingSuggestions = featureConfigs.some(
    (featureConfig) => featureConfig.name === 'SUPPRESS_PRICING_SUGGESTIONS'
  );

  // If the account was previously an SMB account before migration to Enterprise
  const wasSmbMigrated = accountFeatureConfigs?.wasSmb ?? false;

  return {
    suppressPricingSuggestions,
    wasSmbMigrated,
    migratedFromSmbDate: accountFeatureConfigs?.migratedFromSmbDate ?? null,
  };
}
